import { useIntl } from "react-intl";

const KnowledgeBaseReports = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.KnowledgeBaseReports.header",
            defaultMessage: "Knowledge base reports"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.KnowledgeBaseReports.body",
            defaultMessage:
                "Knowledge base article reports show how often an article is shared, viewed, and voted as helpful. There are two default reports that provide information on how your knowledge base articles are performing: Requests deflected and Requests resolved."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default KnowledgeBaseReports;
